import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/invgamma/cdf';
import __var_2__ from '@stdlib/stats/base/dists/invgamma/ctor';
import __var_3__ from '@stdlib/stats/base/dists/invgamma/entropy';
import __var_4__ from '@stdlib/stats/base/dists/invgamma/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/invgamma/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/invgamma/mean';
import __var_7__ from '@stdlib/stats/base/dists/invgamma/mode';
import __var_8__ from '@stdlib/stats/base/dists/invgamma/pdf';
import __var_9__ from '@stdlib/stats/base/dists/invgamma/quantile';
import __var_10__ from '@stdlib/stats/base/dists/invgamma/skewness';
import __var_11__ from '@stdlib/stats/base/dists/invgamma/stdev';
import __var_12__ from '@stdlib/stats/base/dists/invgamma/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace invgamma
*/
var invgamma = {};

/**
* @name cdf
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/cdf}
*/
setReadOnly( invgamma, 'cdf', __var_1__);

/**
* @name InvGamma
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/ctor}
*/
setReadOnly( invgamma, 'InvGamma', __var_2__);

/**
* @name entropy
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/entropy}
*/
setReadOnly( invgamma, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/kurtosis}
*/
setReadOnly( invgamma, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/logpdf}
*/
setReadOnly( invgamma, 'logpdf', __var_5__);

/**
* @name mean
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/mean}
*/
setReadOnly( invgamma, 'mean', __var_6__);

/**
* @name mode
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/mode}
*/
setReadOnly( invgamma, 'mode', __var_7__);

/**
* @name pdf
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/pdf}
*/
setReadOnly( invgamma, 'pdf', __var_8__);

/**
* @name quantile
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/quantile}
*/
setReadOnly( invgamma, 'quantile', __var_9__);

/**
* @name skewness
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/skewness}
*/
setReadOnly( invgamma, 'skewness', __var_10__);

/**
* @name stdev
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/stdev}
*/
setReadOnly( invgamma, 'stdev', __var_11__);

/**
* @name variance
* @memberof invgamma
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/invgamma/variance}
*/
setReadOnly( invgamma, 'variance', __var_12__);


// EXPORTS //
export default invgamma;

export { __var_1__ as cdf, __var_2__ as InvGamma, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as mode, __var_8__ as pdf, __var_9__ as quantile, __var_10__ as skewness, __var_11__ as stdev, __var_12__ as variance};